import React from "react";
import {
  Factory, ShieldCheck, Leaf, Palette, Truck, BadgeCheck, Tag, Boxes
} from "lucide-react";

const features = [
  { icon: <Factory size={20} />, title: "Advanced Manufacturing", desc: "Automated high-speed production lines and German-engineered machinery." },
  { icon: <ShieldCheck size={20} />, title: "Food Grade Certified", desc: "Virgin food-grade paper, FSSAI compliant, lab-tested for safety." },
  { icon: <Leaf size={20} />, title: "Eco-Friendly Production", desc: "Biodegradable materials and energy-efficient manufacturing." },
  { icon: <Palette size={20} />, title: "Custom Printing", desc: "Up to 6-color flexo printing for striking brand identity." },
  { icon: <Truck size={20} />, title: "Pan India Distribution", desc: "20+ partner network. On-time delivery across India." },
  { icon: <BadgeCheck size={20} />, title: "Quality Control", desc: "100% in-line inspection at every production stage." },
  { icon: <Tag size={20} />, title: "Competitive Pricing", desc: "Direct from manufacturer pricing for wholesalers and distributors." },
  { icon: <Boxes size={20} />, title: "Reliable Supply", desc: "Vertically integrated supply chain for uninterrupted bulk orders." },
];

export const WhyChooseUs = () => {
  return (
    <section data-testid="why-choose-us" className="py-24 md:py-32 bg-neutral-50/60 border-y border-neutral-200/70">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="max-w-3xl">
          <div className="font-mono-vc text-xs uppercase tracking-[0.25em] vc-text-gradient font-bold">
            Why Choose VersaCorp
          </div>
          <h2 className="mt-4 font-display text-4xl md:text-5xl font-extrabold leading-[1.05] text-neutral-900">
            Eight reasons businesses choose us as their <span className="vc-text-gradient">disposables partner</span>.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {features.map((f, i) => (
            <div
              key={f.title}
              data-testid={`feature-card-${i}`}
              className="group relative rounded-2xl bg-white border border-neutral-200 p-6 hover:border-neutral-300 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-xl vc-gradient text-white flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                {f.icon}
              </div>
              <div className="font-display text-lg font-bold text-neutral-900 leading-snug">
                {f.title}
              </div>
              <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{f.desc}</p>
              <div className="absolute right-4 top-4 font-mono-vc text-[10px] text-neutral-300">
                0{i + 1}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
